// Curated font catalogue for the Landing-Editor typography picker.
// All these are pre-loaded in index.html.

export const HEADING_FONTS = [
  // Serifs (elegant, editorial)
  { value: "Cormorant Garamond", label: "Cormorant Garamond", category: "Serif" },
  { value: "Playfair Display", label: "Playfair Display", category: "Serif" },
  { value: "Lora", label: "Lora", category: "Serif" },
  { value: "Merriweather", label: "Merriweather", category: "Serif" },
  { value: "EB Garamond", label: "EB Garamond", category: "Serif" },
  { value: "DM Serif Display", label: "DM Serif Display", category: "Serif" },
  { value: "Libre Baskerville", label: "Libre Baskerville", category: "Serif" },

  // Sans-serifs (clean, modern)
  { value: "Inter", label: "Inter", category: "Sans" },
  { value: "Manrope", label: "Manrope", category: "Sans" },
  { value: "DM Sans", label: "DM Sans", category: "Sans" },
  { value: "Plus Jakarta Sans", label: "Plus Jakarta Sans", category: "Sans" },
  { value: "Outfit", label: "Outfit", category: "Sans" },
  { value: "Poppins", label: "Poppins", category: "Sans" },
  { value: "Montserrat", label: "Montserrat", category: "Sans" },

  // Display (impactful, headline-only)
  { value: "Bebas Neue", label: "Bebas Neue", category: "Display" },
  { value: "Anton", label: "Anton", category: "Display" },
  { value: "Oswald", label: "Oswald", category: "Display" },
  { value: "Archivo Black", label: "Archivo Black", category: "Display" },
];

export const BODY_FONTS = [
  { value: "Inter", label: "Inter" },
  { value: "Manrope", label: "Manrope" },
  { value: "DM Sans", label: "DM Sans" },
  { value: "Plus Jakarta Sans", label: "Plus Jakarta Sans" },
  { value: "Outfit", label: "Outfit" },
  { value: "Poppins", label: "Poppins" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Lora", label: "Lora" },
];

export const DEFAULT_HEADING_FONT = "Cormorant Garamond";
export const DEFAULT_BODY_FONT = "Manrope";
